import { Box, Spin } from '@briq/shared'

export type PageLoaderProps = Box.BoxProps

export const PageLoader = Spin.PageLoader
